var igg_wap_tc;
var now_id=0;

function igg_tc_init()
{
	var igg_type_ids=[];
	var igg_tit="";
	var igg_id="";
	var igg_t_arr=[];
	var igg_options=[];
	var igg_html="";
	var igg_tag="";
	var igg_obj;
	var igg_datas=[];
	var str="";
	var igg_tj={cj:0,target_money:10000,cj_money:0,cj_money_per:0};
	var igg_dollar={};//套餐标准成交金额
    var igg_dws='';
	var daoqi={7994434617570:"2023-02-15 00:00:00",8027205468386:'2023-03-26 16:00:00',7990198763746:"2023-05-30 00:00:00", "8115651150050": "2023-08-30 00:00:00"};//众筹到期时间
    //8027205468386 - A100
	igg_dollar[43731334234338]=65.55;//Panasonic LUMIX
	igg_dollar[43731334267106]=94.05;

    igg_dollar[43745205715170]=65.55;//fx30
	igg_dollar[43745205747938]=94.05;

    //A100
    igg_dollar[43842025357538]=525.90;
    igg_dollar[43842025390306]=474.00;
    igg_dollar[43842025423074]=41.80;

	igg_dollar[43732863484130]=69.00;
	igg_dollar[43732863516898]=99.00;

    igg_dollar[44186273743074]=1199.00;
    igg_dollar[44186273874146]=3598.00;
    igg_dollar[44186274005218]=4157.00;
    igg_dollar[44186274136290]=5996.00;
    igg_dollar[44186274267362]=6555.00;
  
    igg_dollar[43928847253730]=2.00;
    igg_dollar[43928847220962]=1.00;
  
	var vv=0;
    var igg_q='';
    var zhuobi=0;
    var zhuobi_i=1;

    var show_num = 0;

    var continue_array = [""];

    // 用于组合套餐，第一次插入后，后面相同名称套餐的跳过
    var check_have_array = [""];
    var check_have_array2 = [""];
    
    now_id=$(".product-sr-detail").data("productid");
    now_id=('s'+now_id).substr(9,8);
    //货币单位

	for(let i in igg_tc_titles)
	{
        if (continue_array.indexOf(igg_tc_ids[i]) != -1) {
          continue;
        }
      
        if(i==0)
        {
          str=igg_tc_prices[i].substr(0,1);
          if(str=='€')
          {
            igg_q='eu_';//欧元时，可调用欧元图片
          }
          else if(str=='£')
          {
            //igg_q='uk_';
          }
        }
		igg_t_arr=igg_tc_titles[i].split(" / ");

        /*---------------------这是多复合套餐的情况
		if(igg_t_arr.length!=2)
		{
			continue;
		}

        
		if(igg_tit!=igg_t_arr[0])
		{
			igg_tit=igg_t_arr[0];//获取区分标题
			igg_id=igg_tc_ids[i];
			igg_type_ids.push(igg_id);
			igg_options[igg_id]="";
			//igg_datas[igg_id]={title:igg_tit,kakou:[],ku:igg_ku_datas[i],sell:1000-igg_ku_datas[i]};
			igg_datas[igg_id]={title:igg_tit,kakou:[],sell:0};
			
		}
		*/

        igg_tit=igg_t_arr[0];//获取区分标题
		igg_id=igg_tc_ids[i];
		igg_type_ids.push(igg_id);
		igg_options[igg_id]="";
		igg_datas[igg_id]={title:igg_tit,kakou:[],sell:0};
		
		//---上面这是简单套餐的情况
		
		$(".test-box-append").append("<div>ffff:"+ igg_tc_prices[i] + "," + igg_ku_datas[i]+"</div>");

		igg_options[igg_id]+="<option value='"+igg_tc_ids[i]+"' price='"+igg_tc_prices[i]+"' compare_at_price='"+igg_compare_at_prices[i]+"'>"+igg_t_arr[1]+"</option>";

        // 组合套餐
        if (check_have_array2.indexOf(igg_datas[igg_id]['title']) != -1) {
            continue;
        }
        check_have_array2.push(igg_datas[igg_id]['title']);
		
		$(".test-box-append").append("<div>"+igg_ku_datas[i]+"</div>");
      
        if(igg_id=='43842025423074')
        {
          igg_datas[igg_id]['sell']+=1000-igg_ku_datas[i];//本套餐，下的所有卡口总售出--括号为作假数
          igg_tj['cj']+=1000-igg_ku_datas[i];//累计总售出数--括号为作假数
        }
        else{
          // igg_datas[igg_id]['sell']+=1-igg_ku_datas[i]+(zhuobi_i+zhuobi);//本套餐，下的所有卡口总售出--括号为作假数
          // igg_tj['cj']+=1-igg_ku_datas[i]+(zhuobi_i+zhuobi);//累计总售出数--括号为作假数
          // igg_datas[igg_id]['sell']+=igg_ku_datas[i]+(zhuobi_i+zhuobi);//本套餐，下的所有卡口总售出--括号为作假数
          // igg_tj['cj']+=igg_ku_datas[i]+(zhuobi_i+zhuobi);//累计总售出数--括号为作假数
          igg_datas[igg_id]['sell']+=1000-igg_ku_datas[i] + 6;//本套餐，下的所有卡口总售出--括号为作假数
          igg_tj['cj']+=1000-igg_ku_datas[i] + 6;//累计总售出数--括号为作假数
        }
		zhuobi_i=zhuobi_i+1;
		
		//捕获
		igg_datas[igg_id]['kakou'].push(igg_t_arr[1]);
	}

	for(let j in igg_type_ids)
	{
        if (continue_array.indexOf(igg_type_ids[j]) != -1) {
          continue;
        }
		
		// $(".test-box-append").append("<div>gggg:"+igg_ku_datas[j]+"</div>");

		igg_id=igg_type_ids[j];
      
        // 组合套餐
        if (check_have_array.indexOf(igg_datas[igg_id]['title']) != -1) {
    		igg_obj=$(".check_have_"+igg_datas[igg_id]['title'].replace(/\s/g, "")).find("form");
        	igg_obj.find(".igg-rproduct-content").find(".igg-options").find("select").append(igg_options[igg_id]);//选择框

            var str_js_num = igg_obj.find(".igg-rproduct-content").find(".igg-form-li-sku").attr("ysnum");
            igg_obj.find(".igg-rproduct-content").find(".igg-form-li-sku").attr("ysnum", (str_js_num + "," + (1000-igg_ku_datas[j])));
          
            var add_str_num = igg_obj.find(".igg-rproduct-content").find(".igg-form-li-sku").text();
    		$(".test-box-append").append("<div>gggg:"+(1000-igg_ku_datas[j])+"</div>");

            // igg_obj.find(".igg-rproduct-content").find(".igg-form-li-sku")
          
    		igg_obj.find(".igg-rproduct-content").find(".igg-form-li-sku").text("Inventory left: "+(200-(1000-igg_ku_datas[j]+30)));//sku
          
            continue;
        }
        check_have_array.push(igg_datas[igg_id]['title']);
      
		//$("#igg_select"+igg_id).html(igg_options[igg_id]);
		igg_tag="igg-tc-li-"+igg_id;
		check_igg_tag="igg-tc-li-"+igg_id+' check_have_' + igg_datas[igg_id]['title'].replace(/\s/g, "");
		$(".igg-ul-form").append('<li class="'+check_igg_tag+'">'+$(".igg-tc-demo").html()+'</li>');
		// $(".igg-ul-form").append('<li class="'+igg_tag+'">'+$(".igg-tc-demo").html()+'</li>');
		igg_obj=$("."+igg_tag).find("form");
		//str=igg_datas[igg_id]['kakou']?"("+igg_datas[igg_id]['kakou'].join("/")+")":"";//复合套餐使用这个
        str="";
		igg_obj.find(".igg-img").find("img").attr("src","https://s-cf.sirui.com/store/tc/"+igg_q+igg_id+".jpg?v=1.001");//测试
		igg_obj.find(".igg-rproduct-content").find(".igg-options").find("select").html(igg_options[igg_id]);//选择框
		igg_obj.find(".igg-rproduct-content").find(".igg-form-li-title").text(igg_datas[igg_id]['title']+str);//标题
      
		igg_obj.find(".igg-rproduct-content").find(".igg-form-li-sku").attr("ysnum", (1000-igg_ku_datas[j]));//sku
      
		igg_obj.find(".igg-rproduct-content").find(".igg-form-li-sku").text("Inventory left: "+(200-(1000-igg_ku_datas[j]+30)));//sku
		// igg_obj.find(".igg-rproduct-content").find(".igg-form-li-sku").text(igg_sku[j]);//sku
		igg_obj.find(".igg-rproduct-content").find(".igg-li-ku1").html("<span>"+igg_datas[igg_id]['sell']+"</span>"+" claimed");//出售数据
		
      
		str=igg_obj.find(".igg-rproduct-content").find(".igg-options").find("option:selected").attr("price");
		
        igg_obj.find(".igg-rproduct-content").find(".igg-form-li-price").find("span").find("span").text(str);
		str=igg_obj.find(".igg-rproduct-content").find(".igg-options").find("option:selected").attr("compare_at_price");
		
		igg_obj.find(".igg-rproduct-content").find(".igg-form-li-yprice").find("span").find("span").text(str);
		
		//--下面是计算进度条
        
		vv=igg_dollar[igg_id] && igg_dollar[igg_id]>0 && igg_dollar[igg_id]<100000?igg_dollar[igg_id]:69;
		igg_tj['cj_money']=igg_tj['cj_money']-0+vv*igg_datas[igg_id]['sell'];//本套餐下的所有卡口累计成交总金额
		
	}

    var total_cj_num = 0;
    var total_cj_money = 0;

    var str_js_str1 = $(".igg-tc-li-44186273743074").find(".igg-form-li-sku").attr("ysnum");
    var arr_js_arr1 = str_js_str1.split(',');
    var sum_js_arr1 = 0;
    for (var js_index = 0; js_index < arr_js_arr1.length; js_index++) {
      sum_js_arr1+=parseInt(arr_js_arr1[js_index]);
    }
    $(".test-box-append").append("<div>ssss:"+sum_js_arr1+"</div>");
    $(".igg-tc-li-44186273743074").find(".igg-form-li-sku").text("Inventory left: " + (200 - sum_js_arr1));
    total_cj_num += sum_js_arr1;
    total_cj_money += (sum_js_arr1 * 1199);

    var str_js_str1 = $(".igg-tc-li-44186273874146").find(".igg-form-li-sku").attr("ysnum");
    var arr_js_arr1 = str_js_str1.split(',');
    var sum_js_arr1 = 0;
    for (var js_index = 0; js_index < arr_js_arr1.length; js_index++) {
      sum_js_arr1+=parseInt(arr_js_arr1[js_index]);
    }
    $(".test-box-append").append("<div>ssss:"+sum_js_arr1+"</div>");
    $(".igg-tc-li-44186273874146").find(".igg-form-li-sku").text("Inventory left: " + (20 - sum_js_arr1));
    total_cj_num += sum_js_arr1;
    total_cj_money += (sum_js_arr1 * 3598);

    var str_js_str1 = $(".igg-tc-li-44186274005218").find(".igg-form-li-sku").attr("ysnum");
    var arr_js_arr1 = str_js_str1.split(',');
    var sum_js_arr1 = 0;
    for (var js_index = 0; js_index < arr_js_arr1.length; js_index++) {
      sum_js_arr1+=parseInt(arr_js_arr1[js_index]);
    }
    $(".test-box-append").append("<div>ssss:"+sum_js_arr1+"</div>");
    $(".igg-tc-li-44186274005218").find(".igg-form-li-sku").text("Inventory left: " + (20 - sum_js_arr1));
    total_cj_num += sum_js_arr1;
    total_cj_money += (sum_js_arr1 * 4157);

    var str_js_str1 = $(".igg-tc-li-44186274136290").find(".igg-form-li-sku").attr("ysnum");
    var arr_js_arr1 = str_js_str1.split(',');
    var sum_js_arr1 = 0;
    for (var js_index = 0; js_index < arr_js_arr1.length; js_index++) {
      sum_js_arr1+=parseInt(arr_js_arr1[js_index]);
    }
    $(".test-box-append").append("<div>ssss:"+sum_js_arr1+"</div>");
    $(".igg-tc-li-44186274136290").find(".igg-form-li-sku").text("Inventory left: " + (20 - sum_js_arr1));
    total_cj_num += sum_js_arr1;
    total_cj_money += (sum_js_arr1 * 5996);

    var str_js_str1 = $(".igg-tc-li-44186274267362").find(".igg-form-li-sku").attr("ysnum");
    var arr_js_arr1 = str_js_str1.split(',');
    var sum_js_arr1 = 0;
    for (var js_index = 0; js_index < arr_js_arr1.length; js_index++) {
      sum_js_arr1+=parseInt(arr_js_arr1[js_index]);
    }
    $(".test-box-append").append("<div>ssss:"+sum_js_arr1+"</div>");
    $(".igg-tc-li-44186274267362").find(".igg-form-li-sku").text("Inventory left: " + (20 - sum_js_arr1));
    total_cj_num += sum_js_arr1;
    total_cj_money += (sum_js_arr1 * 6555);


    var str_js_str1 = $(".igg-tc-li-43928847220962").find(".igg-form-li-sku").attr("ysnum");
    var arr_js_arr1 = str_js_str1.split(',');
    var sum_js_arr1 = 0;
    for (var js_index = 0; js_index < arr_js_arr1.length; js_index++) {
      sum_js_arr1+=parseInt(arr_js_arr1[js_index]);
    }
    $(".test-box-append").append("<div>ssss:"+sum_js_arr1+"</div>");
    $(".igg-tc-li-43928847220962").find(".igg-form-li-sku").text("Inventory left: " + (200 - sum_js_arr1));
    total_cj_num += sum_js_arr1;
    total_cj_money += (sum_js_arr1 * 1);
  
    var str_js_str1 = $(".igg-tc-li-43928847253730").find(".igg-form-li-sku").attr("ysnum");
    var arr_js_arr1 = str_js_str1.split(',');
    var sum_js_arr1 = 0;
    for (var js_index = 0; js_index < arr_js_arr1.length; js_index++) {
      sum_js_arr1+=parseInt(arr_js_arr1[js_index]);
    }
    $(".test-box-append").append("<div>ssss:"+sum_js_arr1+"</div>");
    $(".igg-tc-li-43928847253730").find(".igg-form-li-sku").text("Inventory left: " + (200 - sum_js_arr1));
    total_cj_num += sum_js_arr1;
    total_cj_money += (sum_js_arr1 * 2);

  


    $(".test-box-append").append("<div>wwwwwwww:"+total_cj_num+","+total_cj_money+"</div>");
	
	
	//--------------------进度条汇总统计
	$(".igg-progress-bar").css("display","flex");
	igg_tj['cj_money']=Math.ceil(igg_tj['cj_money']);
	igg_tj['cj_money_per']=Math.ceil(igg_tj['cj_money']/igg_tj['target_money']*100);//完成金额百分比
	
	
	$(".igg-total-money").text('$'+igg_doumoney(igg_tj['cj_money']));//总成交金额
	$(".igg-total-backers").text(igg_tj['cj']);//成交数量
	$(".igg-finish-target").text('$'+igg_tj['target_money']);//目标金额				
	$(".igg-finish-per").text(igg_tj['cj_money_per']+'%');//完成百分比

    // 修改点
    $(".igg-total-money").text("$"+total_cj_money);
    $(".igg-total-backers").text(total_cj_num);	
	$(".igg-finish-per").text((Math.ceil(total_cj_money/igg_tj['target_money']*100))+'%');//完成百分比

    var vv=igg_tj['cj_money_per']>100?100:igg_tj['cj_money_per'];
    $(".igg-line-bar").css("width",vv+"%");//进度条宽度
	

  
	//--------------------进度条汇总统计
	var igg_days=Math.ceil((new Date(daoqi[$(".product-sr-detail").data("productid")]).getTime() - new Date().getTime())/1000/60/60/24);
	igg_days=igg_days<=0?1:igg_days;
	$(".igg-finish-days").data("value",igg_days);
	$(".igg-finish-days").text(igg_days);

    
    

    
    
  
}


$(".igg-wap-link .igg-sele-top").click(function(){
  var igg_h=$(".igg-cp-right").height()+$(".igg-cp-right").parent().prev().height()+$(".header-sticky-wrapper").height()-40;
  $(document).scrollTop(igg_h);
});



//点击客服

window.setTimeout(function(){
    $(".view_user_chat").click(function(){
      $(".msui-widget-button").click();
    });

  $(".igg-link-bars").removeClass("igg-link-bars-hide");

  $(".igg-link-bars a").click(function(){
	var i=$(this).data("id");
    $(this).addClass("cur").siblings().removeClass("cur");
	$("#station-tabs-0 .station-tabs-content").removeClass("is-active");
	$("#"+i).addClass("is-active");
	
});
  
  
},2000);


//复制链接

$(".igg-icon-link").click(function(){
 
  var copyVal = document.getElementById('copy_link');
  copyVal.select();
  document.execCommand('copy');
  alert("Copy link succeeded ！");
})

//---留言开始
function igg_get_discussion_list()
{
	$.post("https://awards.sirui.com/index/hf/getmsgs.html",{ud:now_id,typeid:now_id},function(data){
		$(".igg-discussion-ul").html(data);
      $(".igg-discussion-send").text("Send");
	});

}

function igg_discussion()
{
	igg_get_discussion_list();//加载
	//
	//提交
	$(".igg-discussion-send").click(function(){
	if(!$(".igg-discussion-msg").val())
	{
		$(".igg-discussion-msg").val('').focus();
		return false;
	}
    
    $(".igg-discussion-send").text("Sending..");
	$.post("https://awards.sirui.com/index/hf/msgs.html",{content:$(".igg-discussion-msg").val(),typeid:now_id},function(data){
        $(".igg-discussion-msg").val('');
    	igg_get_discussion_list(1);
	});
	
	
});

}

//初始化
function igg_discussion_init()
{
		$.post("https://awards.sirui.com/index/hf/index.html",{},function(data){
			$("#st-discussion_0-3").find(".station-tabs-content-inner").html(data);//加载留言页面
			igg_discussion();
		});

  //var gstr=$(".product__video").attr("allow").replace(/autoplay;/i,'');
  
  //$(".product__video").attr("allow",gstr);
  
}

window.setTimeout(igg_discussion_init,1500);

//---留言结束
igg_tc_init();



function igg_doumoney(money)
  {
    if(money<1000){
      return money;
    }
    var str='s'+money;
    return str.substr(1,str.length-4)+','+str.substr(-3,3);
  }





